import ContentLoader, { Rect } from "react-content-loader/native";
import { VStack } from "@gluestack-ui/themed";

export const SelectTransactionsListLoading = () => {
  return (
    <>
      <VStack height="$12" mb="$2" mt="$4">
        <ContentLoader backgroundColor="#CDCDCD" speed={0.5}>
          <Rect x="0" y="0" rx="12" ry="12" height="42" width="99%" />
        </ContentLoader>
      </VStack>
      <VStack height="$12" mb="$2">
        <ContentLoader backgroundColor="#CDCDCD" speed={0.5}>
          <Rect x="0" y="0" rx="12" ry="12" height="42" width="99%" />
        </ContentLoader>
      </VStack>
      <VStack height="$12" mb="$2">
        <ContentLoader backgroundColor="#CDCDCD" speed={0.5}>
          <Rect x="0" y="0" rx="12" ry="12" height="42" width="99%" />
        </ContentLoader>
      </VStack>
      <VStack height="$12" mb="$2">
        <ContentLoader backgroundColor="#CDCDCD" speed={0.5}>
          <Rect x="0" y="0" rx="12" ry="12" height="42" width="99%" />
        </ContentLoader>
      </VStack>
      <VStack height="$12" mb="$2">
        <ContentLoader backgroundColor="#CDCDCD" speed={0.5}>
          <Rect x="0" y="0" rx="12" ry="12" height="42" width="99%" />
        </ContentLoader>
      </VStack>
      <VStack height="$12" mb="$2">
        <ContentLoader backgroundColor="#CDCDCD" speed={0.5}>
          <Rect x="0" y="0" rx="12" ry="12" height="42" width="99%" />
        </ContentLoader>
      </VStack>
    </>
  );
};
